<div class="wrapper">
    <div class="grid" [class.menu-first]="menuFirst">
        <div class="header">
            <router-outlet name="header"></router-outlet>
        </div>
        <!-- Kafelek zostaje zawsze: na pulpicie to on maluje beżowe tło pod
             paskiem narzędzi. Poza widokiem drzewa jest tylko pusty. -->
        <div class="tree-selector" [class.tree-selector-empty]="!showTreeCount">
            @if (showTreeCount) {
                <app-treeselector></app-treeselector>
            }
        </div>
        <div class="toolbar">
            <router-outlet name="toolbar"></router-outlet>
        </div>
        <div class="navbar">
            <router-outlet name="navbar"></router-outlet>
        </div>
        <div id="main" class="main">
            <router-outlet></router-outlet>
        </div>
        <div class="footer">
            @if (treeAdmins) {
                <p class="footer-tree">{{ 'footer.treeKeptBy' | t: { tree: treeTitle, admins: treeAdmins } }}</p>
            }
            <!-- numer wersji prowadzi do historii zmian; ustawienia zgody stoja
                 w TEJ SAMEJ linii - osobny wiersz podnosil stopke o ~19px na
                 kazdej stronie -->
            <h3>Genealogy Cards
                <a class="version-link" [routerLink]="['/changelog']"
                    [title]="'changelog.versionLink' | t">v{{ version }}</a>
                &copy; {{ copyright }}
                <a class="consent-link" (click)="openConsent()">{{ 'main.consentSettings' | t }}</a></h3>
        </div>
    </div>
</div>